define(
  'modules/mute',
  [
    'jquery',
    'modules/tracking',
    'modules/spin-loader'
  ],
  function (
    $,
    M_Tracking,
    M_SpinLoader
  ) {
    'use strict';

    var classes = {
      isActive: 'is--active'
    };
    var selectors = {
      muteToggle: '.js-mute-toggle',
      muteableVideos: '.js-video-muteable'
    };
    var state = {
      isMuted: false
    };
    var $muteToggle
      , $muteableVideos;


    function init () {
      getElems();
      bindEvents();
    }

    function getElems () {
      $muteToggle = $(selectors.muteToggle);
      $muteableVideos = $(selectors.muteableVideos);
    }

    function bindEvents () {
      $muteToggle.on('click', onMuteToggleClick);
    }

    function setMuteableVideosMuted (mute) {
      var muteableVideoElems = $muteableVideos.get();

      for (var i = 0; i < muteableVideoElems.length; i++) {
        muteableVideoElems[i].muted = mute;
      }
    }

    function onMuteToggleClick (e) {
      e.preventDefault();
      e.stopPropagation();

      state.isMuted = !state.isMuted;

      if (state.isMuted) {
        setMuteableVideosMuted(true);
        M_SpinLoader.mute();
        $muteToggle.addClass(classes.isActive)
      } else {
        setMuteableVideosMuted(false);
        M_SpinLoader.unmute();
        $muteToggle.removeClass(classes.isActive);
      }

      M_Tracking.trackEvent('click-cta', 'Audio Toggle ' + (state.isMuted ? 'Off' : 'On'));
    }

    return {
      init: init
    }
});

